import React from 'react'
import { connect } from 'react-redux'
import HeaderTitle from '../Header/HeaderTitle'
import {
  Grid,
  Typography,
  Card,
  CircularProgress,
  AppBar,
  Tabs,
  Tab,
} from '@mui/material'
import AvailablePortInfoTab from './AvailablePortInfoTab'
import CreateSheetsTab from './CreateSheetsTab'
import CreateScopeTab from './CreateScopeTab'
import GeneratePlatformDataSheetsTab from './GeneratePlatformDataSheetsTab'
import { handleFireflySendEvent } from '../Utils/FireFlyVnextHelpers'

export class CreateSmartsheets extends React.Component {
  constructor(props) {
    super(props)
    this.availableTabs = [
      {
        name: 'Create Cutsheets/Supplemental Sheets',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN', 'APP-OAUTH2-ZIPTIE-NE'],
      },
      {
        name: 'Create Scope Sheet',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN'],
      },
      {
        name: 'Available Port Information',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN'],
      },
      {
        name: 'Generate Platform Data Sheets',
        requiredAdGroups: ['APP-ZIPTIE-ADMIN'],
      },
    ]
    this.state = {
      authorizedTabs: [],
      loading: true,
      selectedTab: 0,
    }
    this.handleTabChange = this.handleTabChange.bind(this)
    this.dialogBox = React.createRef()
  }

  async componentDidMount() {
    const { userInfo } = this.props
    if (userInfo.email !== '') {
      handleFireflySendEvent(
        'PAGE_VIEW',
        'Create Smartsheets',
        'Create Smartsheets Page Load',
        userInfo,
      )
    }
    const authorizedTabs = this.availableTabs.filter(function (tab) {
      return (
        tab.requiredAdGroups.filter((group) =>
          userInfo.memberOf.includes(group),
        ).length > 0 || tab.requiredAdGroups.length === 0
      )
    })
    this.setState({
      authorizedTabs: authorizedTabs,
      loading: false,
      selectedTab: authorizedTabs[0].name,
    })
  }

  handleTabChange(event, newTab) {
    this.setState({
      selectedTab: newTab,
    })
  }

  render() {
    const { classes, userInfo } = this.props

    let tabLabels = []
    this.state.authorizedTabs.forEach((tab) => {
      let tabLabel = <Tab key={tab.name} label={tab.name} value={tab.name} />
      tabLabels.push(tabLabel)
    })

    return (
      <div>
        <HeaderTitle title="Create Smartsheets" />
        {this.state.loading ? (
          <Grid
            container
            spacing={16}
            justifyContent={'center'}
            className="progress"
          >
            <CircularProgress />
            <Typography className="loading">&nbsp;Loading...</Typography>
          </Grid>
        ) : (
          <Grid item size={{ xs: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Grid item size={{ xs: 12 }}>
                <Card style={{ height: '75vh' }}>
                  <AppBar position="static">
                    <Tabs
                      value={this.state.selectedTab}
                      onChange={this.handleTabChange}
                      variant="scrollable"
                      scrollButtons="auto"
                    >
                      {tabLabels}
                    </Tabs>
                  </AppBar>
                  {this.state.selectedTab ===
                    'Create Cutsheets/Supplemental Sheets' &&
                    (userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') ||
                      userInfo.memberOf.includes('APP-OAUTH2-ZIPTIE-NE')) && (
                      <CreateSheetsTab
                        classes={classes}
                        user={userInfo}
                        handleHelpOpen={this.state.handleHelpOpen}
                      />
                    )}
                  {this.state.selectedTab === 'Create Scope Sheet' &&
                    userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') && (
                      <CreateScopeTab
                        classes={classes}
                        user={userInfo}
                        handleHelpOpen={this.state.handleHelpOpen}
                      />
                    )}
                  {this.state.selectedTab === 'Available Port Information' &&
                    userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') && (
                      <AvailablePortInfoTab
                        classes={classes}
                        user={userInfo}
                        handleHelpOpen={this.state.handleHelpOpen}
                      />
                    )}
                  {this.state.selectedTab === 'Generate Platform Data Sheets' &&
                    userInfo.memberOf.includes('APP-ZIPTIE-ADMIN') && (
                      <GeneratePlatformDataSheetsTab
                        classes={classes}
                        user={userInfo}
                        handleHelpOpen={this.state.handleHelpOpen}
                      />
                    )}
                </Card>
              </Grid>
            </div>
          </Grid>
        )}
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(CreateSmartsheets)
